<template>
  <base-section
    id="customer-reviews"
    class="grey lighten-5"
    space="64"
  >
    <base-section-heading
      icon=""
      space="0"
      title="In Memory of Maureen and John"
    />

    <v-row>
    <v-col
        v-for="(customer, i) in customers"
        :key="i"
        >
        <v-container class="fill-height">
          <v-responsive
            class="mx-auto shrink text-center"
            max-width="90%"
            width="700"
          >
            <base-body
              v-if="customer.review.length>0"
              :text="customer.review"
              tag="em"
              class="mb-3 d-block"
            />

            <v-avatar
              class="mb-2"
              size="144"
            >
              <base-img :src="require(`@/assets/avatars/${customer.avatar}`)" />
            </v-avatar>

            <base-title
              :title="customer.name"
              space="0"
            />

            <base-subtitle :title="customer.role" />

            <v-container fluid>
              <v-row>
                <!--
                <v-col
                  v-for="card in cards"
                  :key="card.title"
                  cols="12"
                  sm="12"
                  md="12"
                >
                -->
                  <base-info-card
                    align="center"
                    dark
                    v-bind="customer.html"
                  />
                  <!--
                </v-col>
                -->
              </v-row>
            </v-container>
            </v-responsive>
          </v-container>
    <!--
    {{ i }} {{ customer }}
    -->
    </v-col>  <!-- end of loop -->

    <hr>
    <hr>
    <hr>

    </v-row>

    <span class="trace">InMemory2.vue</span>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionCustomerReviews',

    provide: {
      heading: { align: 'center' },
    },

    data: () => ({
      customers: [

        {
          review: '',
          name: 'Maureen Burgess',
          role: 'Truro Environmentalist, Select Board',
          avatar: 'MaureenBurgess_crop50.png',
          html: '',
        },

        {
          review: '',
          name: 'John Hopkins',
          role: 'Truro Environmental Activist',
          avatar: 'Hopkins_John.jpg',
          html: '<a href="https://provincetown.wickedlocal.com/news/20200510/truro-vietnam-vet-activist-john-hopkins-dies-in-costa-rica" target="_page2">Truro Vietnam vet, climate activist John Hopkins dies in Costa Rica</a><br><a href="https://provincetownindependent.org/news/2020/04/30/john-hopkins-dies-in-costa-rica/" target="_page2">John Hopkins Dies in Costa Rica, April 23, 2020</a>',
        },
      ],

      cards: [
        {
          icon: '',
          title: 'Truro Committees',
          text: '',
          html: '<a href="https://provincetown.wickedlocal.com/news/20200510/truro-vietnam-vet-activist-john-hopkins-dies-in-costa-rica" target="_page2">Truro Vietnam vet, climate activist John Hopkins dies in Costa Rica</a><br><a href="https://provincetownindependent.org/news/2020/04/30/john-hopkins-dies-in-costa-rica/" target="_page2">John Hopkins Dies in Costa Rica, April 23, 2020</a>',
        },
        {},
      ],

    }),
  }
</script>

<style lang="sass">
  #customer-reviews
    .v-carousel__controls
      background: transparent

    .base-body
      line-height: 2
</style>
